export default function ($http) {
    return function (groupId) {
        return $http.delete(`/api/vmcaccount/${groupId}`).then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/delete/deleteVmcAccount.js